<template>
    <div class="p-4">
        <div class="default-search-container cover-search-container pt-32 lg:px-28 xl:px-60">
            <a-tabs
                default-active-key="basic"
                :active-key="defaultTab"
                type="card"
                @change="onTabChange"
                :class="{ 'shadow-md rounded-md': defaultTab == 'advance' }"
            >
                <a-tab-pane key="basic" :tab="tabTitle('basic')" :forceRender="true">
                    <form-basic-search :processing="processing" :search_form="search_form" @formSubmit="handleFind" />
                </a-tab-pane>
                <a-tab-pane key="advance" :tab="tabTitle('advance')" :forceRender="true">
                    <form-advance-search
                        :processing="processing"
                        :search_form="search_form"
                        :form_mode="form_mode"
                        @formSubmit="handleFind"
                        @clear="handleClear"
                        @cancel="handleCancel"
                    />
                </a-tab-pane>
            </a-tabs>
        </div>
    </div>
</template>

<script>
import FormBasicSearch from '@/components/forms/covers/BasicSearch.vue';
import FormAdvanceSearch from '@/components/forms/covers/AdvanceSearch.vue';

import store from '@/store';

export default {
    components: {
        FormBasicSearch,
        FormAdvanceSearch,
    },
    data() {
        return {
            search_form: {
                basic_search: '',
                cover_id: '',
                cover_type: '',
                reg_no: '',
                chassis_no: '',
                engine_no: '',
                all_match: 1,
            },
            form_mode: 'init',
            search_values: {},
            processing: false,
        };
    },
    computed: {
        defaultTab() {
            return this.$store.state.system.search_state_covers;
        },
    },
    methods: {
        setTab(tab) {
            store.dispatch('system/updateSearchStateCovers', tab);
        },
        tabTitle(key) {
            switch (key) {
                case 'basic':
                    return this.$t('covers.tabs.basic');
                case 'advance':
                    return this.$t('covers.tabs.advance');
            }
        },
        onTabChange(key) {
            this.handleClear();

            switch (key) {
                case 'basic':
                    this.setTab(key);
                    break;
                case 'advance':
                    this.setTab(key);
                    break;
            }
        },
        handleFind() {
            this.search_values = this.search_form;

            switch (this.$store.state.system.search_state_covers) {
                case 'basic':
                    if (this.search_values.basic_search == '') {
                        this.$notification.error({
                            message: this.$t('covers.notifications.error.basic_empty'),
                        });
                        return;
                    }
                    break;
                case 'advance':
                    if (
                        this.search_values.cover_id == '' &&
                        this.search_values.cover_type == '' &&
                        this.search_values.reg_no == '' &&
                        this.search_values.chassis_no == '' &&
                        this.search_values.engine_no == ''
                    ) {
                        this.$notification.error({
                            message: this.$t('covers.notifications.error.advance_empty'),
                        });
                        return;
                    }

                    if (
                        (this.search_values.cover_id != '' && this.search_values.cover_type == '') ||
                        (this.search_values.cover_id == '' && this.search_values.cover_type != '')
                    ) {
                        this.$notification.error({
                            message: this.$t('covers.notifications.error.coverid_or_covertype_required'),
                        });
                        return;
                    }

                    break;
            }

            this.processSearchValues({
                ...this.search_values,
            });
        },
        handleClear() {
            this.processing = true;

            this.search_form = {
                basic_search: '',
                cover_id: '',
                cover_type: '',
                reg_no: '',
                chassis_no: '',
                engine_no: '',
                all_match: 1,
            };

            this.processing = false;
        },
        handleCancel() {
            store.dispatch('system/updateSearchStateCovers', 'basic');

            this.handleClear();
        },
        processSearchValues(data) {
            this.processing = true;

            if (this.$store.getters['user/isMultiAssociation']) {
                data.association_id = this.$store.getters['user/currentAssociationId'];
            }

            this.$http
                .post('/api/covers/search', data)
                .then((response) => {
                    this.processing = false;

                    if (response.data.status == 'success') {
                        this.$router.push({
                            name: 'home-cover-search',
                            params: {
                                id: response.data.id,
                            },
                        });
                    } else {
                        this.$notification.error({
                            message: response.data.message,
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVSH03' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
    },
};
</script>
